import { render } from "./ManageArticle.vue?vue&type=template&id=1cf58a8a&scoped=true"
import script from "./ManageArticle.vue?vue&type=script&lang=js"
export * from "./ManageArticle.vue?vue&type=script&lang=js"

import "./article-responsive.css?vue&type=style&index=0&lang=css&external"
import "./ManageArticle.vue?vue&type=style&index=1&id=1cf58a8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf58a8a"]])

export default __exports__